import { Pipe, PipeTransform } from '@angular/core';
import SampleBranding from '../../../types/sample-vehicle-model/SampleBranding';

@Pipe({
  name: 'sampleBranding',
  standalone: true
})
export class SampleBrandingPipe implements PipeTransform {

  transform(value: SampleBranding | null | undefined): string {
    switch (value) {
      case SampleBranding.STANDARD:
        return 'Standard';
      case SampleBranding.MANUFAKTUR:
        return 'Manufaktur';
      case SampleBranding.MANUFAKTUR_EXCLUSIVE:
        return 'Manufaktur Exclusive';
      default:
        return '';
    }
  }
}
